import React from 'react';
import {Carousel, Icon} from 'antd';
import './index.css';

const AboutUs = () => {
    // 专利证书数据（示例）
    const patents = Array(12).fill(null).map((_, index) => ({
        id: index + 1,
        image: `https://via.placeholder.com/200x280?text=Patent+${index + 1}`,
    }));

    // 奖项证书数据
    const awards = [
        {
            id: 1,
            name: '基于多维度成像技术的医疗器械识别装置',
            image: process.env.SOURCE_URL + '/book1.png',
        },
        {
            id: 2,
            name: '多耗材唯一医疗器械标识码识别装置',
            image: process.env.SOURCE_URL + '/book2.png',
        },
        {
            id: 3,
            name: '一种基于机器视觉的骨钉规格识别检测装置',
            image: process.env.SOURCE_URL + '/book3.png',
        },
        {
            id: 4,
            name: '一种仓储环境手术器械目标检测模型训练及优化方法',
            image: process.env.SOURCE_URL + '/book4.png',
        },
        {
            id: 5,
            name: '一种基于深度学习的两阶段光伏板缺陷检测方法',
            image: process.env.SOURCE_URL + '/book5.png',
        },
        {
            id: 6,
            name: '深度学习多面液晶模组视觉检测装置',
            image: process.env.SOURCE_URL + '/book6.png',
        },
        {
            id: 7,
            name: '高速物料线订单核验视觉机构',
            image: process.env.SOURCE_URL + '/book7.png',
        },
        {
            id: 8,
            name: '一种基于深度学习的手术器械仓储环境清点模型压缩方法',
            image: process.env.SOURCE_URL + '/book8.png',
        },
    ];

    return (
        <div>
            {/* 顶部图片 */}
            <div className="header-image-container">
                <img
                    src={process.env.SOURCE_URL + '/about-us-header.png'}
                    alt="关于我们头图"
                    style={{width: '100%', height: '100%', objectFit: 'cover'}}
                />
            </div>
            <div className="about-us-container">
                {/* 关于我们板块 */}
                <section className="about-section">
                    <h1 className="section-title">关于我们</h1>
                    <p className="company-intro">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上海可明科技有限公司致力于为企业用户提供泛工业AI“质/量”检测的行业整体解决方案，专注于制造业领域的“工业数字化品控”、“医疗器械数量清点”和“大语言模型”方向。
                    </p>
                    <p className="company-intro">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;通过与上海交通大学、东华大学和武汉协和医院深度合作，建设数智化精益管理行业新生态。
                    </p>
                    <p className="company-intro">
                    </p>
                </section>


                {/* 发展历程板块 */}
                <section className="timeline-section">
                    <h2 className="section-title">发展历程</h2>
                    <div className="timeline-container">
                        <img src={process.env.SOURCE_URL + '/timeline.png'} alt="发展历程" className="timeline-image"/>
                    </div>
                </section>

                {/* 奖项与荣誉板块 */}
                <section className="awards-section">
                    <h2 className="section-title">奖项与荣誉</h2>
                    <div className="awards-carousel-container">
                        <Carousel
                            arrows
                            prevArrow={<Icon type="left"/>}
                            nextArrow={<Icon type="right"/>}
                            slidesToShow={3}
                            autoplay
                            autoplaySpeed={3000}
                            pauseOnHover
                        >
                            {awards.map(award => (
                                <div key={award.id} className="award-item">
                                    <img src={award.image} alt={award.name}/>
                                    <p className="award-name">{award.name}</p>
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default AboutUs;
